<template>
  <el-dialog custom-class="max-dialog1256" :title="head" :visible.sync="dialogFormVisible" center  :append-to-body="true"
             :close-on-click-modal="false"
  >

    <el-form :model="form" ref="form1" :rules="rules">
          <!--<template slot="title">-->
            <!--<span>基本信息</span>-->
          <!--</template>-->
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="标题" :label-width="formLabelWidth" prop="title">
                <el-input v-model="form.title" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
      <el-row :gutter="20" v-if="needdate" >
        <el-col :span="20">
          <div style="float: left">
            <el-form-item label="期限" :label-width="formLabelWidth" prop="startdate">
              <el-date-picker
                v-model="form.startdate" :value-format="'yyyy-MM-dd HH:mm:ss'"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
          <div style="float: left">
            <el-form-item label="" :label-width="'5px'" prop="stopdate">
              至
              <el-date-picker
                v-model="form.stopdate" :value-format="'yyyy-MM-dd HH:mm:ss'"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
          <!--<el-form-item label="期限" :label-width="formLabelWidth" prop="startdate">-->
            <!--<el-date-picker style="width:150px"-->
                            <!--v-model="form.startdate" :value-format="'yyyy-MM-dd'"-->
                            <!--type="date"-->
                            <!--placeholder="选择日期">-->
            <!--</el-date-picker>-->
            <!--至-->
            <!--<el-date-picker style="width:150px"-->
                            <!--v-model="form.stopdate" :value-format="'yyyy-MM-dd'"-->
                            <!--type="date"-->
                            <!--placeholder="选择日期">-->
            <!--</el-date-picker>-->
          <!--</el-form-item>-->
        </el-col>

      </el-row>

          <el-row :gutter="25">
            <el-col :span="12">
              <el-form-item label="附件" :label-width="formLabelWidth" prop="attguid">
                <CommonUpload ref="refattguid" :multiple="true" :groupGuid="form.attguid" :disabled="!CanEdit"
                              groupType="inforlist" :limit="10"></CommonUpload>
              </el-form-item>
            </el-col>
          </el-row>
      <el-row :gutter="25">
        <el-col :span="24">
          <el-form-item label="" :label-width="formLabelWidth"  prop="inforcontent">
            <QuillEditor ref="refdiscrip" :toolbarid="toolbarid" :content="form.inforcontent"
                         @on-content-change="changeDiscrip"></QuillEditor>
          </el-form-item>

        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :disabled="isDisable">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {getUsersTree} from '@/api/set/post';
  import {saveData,getDetail} from '@/api/oa/inforlist';
  import {attUUID} from '@/api/attachment';
  import QuillEditor from '../../common/QuillEditor'


  export default {
    name: "InforEdit",
    data() {
      return {
        head:'',
        toolbarid:'inforedittoolbar',
        CanEdit: true,
        isDisable: false,
        dialogFormVisible: false,
        needdate:false,
        form: {  //表单数据
          unitguid:'',
          attguid: '',
          title:'',
          inforcontent:'',
          classcode:'',
          startdate:'',
          stopdate:''
        },
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          title: [
            {required: true, message: '请输入标题', trigger: 'blur'},
          ],
          startdate: [
            {required: true, message: '请选择开始日期', trigger: 'blur'},
          ],
          stopdate: [
            {required: true, message: '请选择结束日期', trigger: 'blur'},
          ],
          inforcontent: [
            {required: true, message: '请输入内容', trigger: 'blur'},
          ]
        },
      }
    },
    methods: {
      show(classcode,classname) {
        this.form.unitguid='';
        var d = new Date();
        var pad = function(n){ return n < 10 ? '0' + n : n; };
        this.form.startdate = d.getFullYear() + '-' + pad(d.getMonth()+1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
        this.form.stopdate = '';
        this.form.attguid = attUUID();
        this.form.classcode = classcode;
        this.form.inforcontent='';
        this.form.title='';
        this.toolbarid = 'inforedittoolbar' + classcode;
        if (classcode == '002') {
          this.head = '最新动态';
          this.needdate = false;
        }
        else if (classcode == '001')
          this.head = '发布公告';
        else {
          this.head = classname;
        }
        this.isDisable=false;
        this.dialogFormVisible = true;
      },
      initData(unitguid) {
        getDetail({unitguid: unitguid}).then(respnse => {
          this.form = respnse.data.obj;
          if (!respnse.data.canedit) {
            this.dialogFormVisible = false;
          }
        });
      },
      changeDiscrip(val) {
        this.form.inforcontent = val;
      },
      saveData() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            this.isDisable = true;
            saveData(this.form).then(response => {
              if (response.data.code == 0) {

                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.$emit('bindInfoList', this.form.classcode)
                this.dialogFormVisible = false;
              } else {
                this.$message.error(response.data.msg);
              }
              //
              this.isDisable = false;
            });
          }
        })
      },
      initForm() {}
    },
    mounted() {
    },
    components: {
      QuillEditor,
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oa/inforlist/InforEdit.vue